import React, { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../../../business.InterfaceLayer/store/services/hooks.service/redux.hook";
import { authSlice } from "../../../../business.InterfaceLayer/store/entities/auth.entity/redux/slice";
import { AUTH_FIELDS } from "../../../../business.InterfaceLayer/store/entities/auth.entity/redux/fields";
import { routeBuilder } from "../routeBuilder.service";
import CabinetRoutesPaths from "../../routes/cabinet.route/cabinet.routesPaths";
import noAuthRoutesPaths from "../../routes/noAuth.route/noAuth.routesPaths";

const CheckNoAuth = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const auth = useAppSelector((state) => state[authSlice.name]);

	useEffect(() => {
		const { [AUTH_FIELDS.TOKEN_ACCESS]: tokenAccess } = auth;
		const isNewPasswordPage = location.pathname.includes(
			noAuthRoutesPaths.PASSWORD_RECOVERY_EMAIL
		);

		if (tokenAccess && !isNewPasswordPage) {
			navigate(routeBuilder([CabinetRoutesPaths.MAIN]));
		}
	}, [auth, navigate, location]);

	return <Outlet />;
};

export default CheckNoAuth;
